// src/features/context/routes.ts
import { lazy } from 'react';
import { Globe } from 'lucide-react';
import { RouteConfig } from '../../types/routing.types';

const ContextDashboard = lazy(() => import('./components/context-dashboard/ContextDashboard'));

export const contextRoutes: RouteConfig[] = [
  {
    path: '/context/*',
    component: ContextDashboard,
    label: 'Contexte',
    icon: Globe,
    showInNav: true,
    navPath: '/context',
  },
];
